import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiOutlineFacebook, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";


function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={12} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I have gained experience working with <span className="purple">Language</span> like
              <i>
                <div
                  className="purple languages"
                  style={{
                    gap: 7,
                    display: "flex",
                    flexWrap: "wrap",
                    margin: "5px 0",
                    alignItems: "flex-start",
                    flexDirection: window.innerWidth <= 768 ? "column" : "row",
                  }}
                >
                  <div>JavaScript,</div>
                  <div>C++</div>
                  <div>and Python</div>

                </div>
              </i>

              <br />
              Here are some of my key <span className="purple">skills:</span>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  margin: "10px 0",
                  alignItems: "flex-start",
                }}
              >
                <div>🌐 HTML</div>
                <div>🎨 CSS</div>
                <div>⚛️ React JS</div>
                <div>⚡ Vite JS</div>
                <div>🔧 Git & GitHub</div>
                <div>🌍 Netlify</div>
                <div>🚀 Vercel</div>
                <div>💨 Tailwind UI</div>
                <div>📦 Bootstrap</div>
                <div>🌼 Daisy UI</div>
                <div>🔥 Firebase</div>
                <div>🖥️ Node JS</div>
                <div>🍃 MongoDB</div>

              </div>
              <br />
              <br />
              My pronouns are
              <i>
                <b> Hamza of All Trades / Master of none </b>
              </i>
            </p>
          </Col>

          <Col md={12} className="myAvtar" style={{ marginTop: "-50px" }}>

            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/AmeerHamzaRafiq?tab=repositories"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/profile.php?id=100092541812255"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://t.ly/jm801"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/sk___hamxa/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;